import { createApplication } from "@angular/platform-browser";
import { createCustomElement } from "@angular/elements";
import { BarrierMapComponent } from "@app/components/barriers/barrier-map/barrier-map.component";
import { IT_ASSET_BASE_PATH } from "design-angular-kit";
import { appConfig } from "@app/app.config";

(async () => {
    const app = await createApplication({
        ...appConfig,
        providers: [
            ...(appConfig.providers || []),
            { provide: IT_ASSET_BASE_PATH, useValue: "/bootstrap-italia/" },
        ],
    });

    const el = createCustomElement(BarrierMapComponent, { injector: app.injector });
    customElements.define("barrier-map", el);
})();
